export const OFFLINE_REWARD_RECEIPT_VERSION =
  "offline-reward-receipt-v2" as const;

export interface OfflineRewardBaseline {
  readonly previousAt: number;
  readonly committedAt: number;
}

export interface OfflineRewardReceipt {
  readonly version: typeof OFFLINE_REWARD_RECEIPT_VERSION;
  readonly rewardId: string;
  readonly gameElapsedMs: number;
  readonly wasCapped: boolean;
  readonly timGained: string;
  readonly resultDigest: string;
  readonly commitRevision: number;
  readonly baseline: OfflineRewardBaseline;
}
